import style from './assignEmp.module.scss';
import cn from 'classnames';
import SearchIcon from '@assets/images/Fireboard/Search';
import { ReactComponent as Table } from '@assets/images/table.svg';
import { ReactComponent as Profile } from '@assets/images/profileFb.svg';
import { ReactComponent as Minus } from '@assets/images/minusFb.svg';
import { ReactComponent as Dash } from '@assets/images/minusLarge.svg';
import Header from './header';
import PropTypes from 'prop-types';
import { FLABEL } from '@containers/Fireboard/fireboardVariables';

const EmployeeView = props => {
  const {
    activeTab,
    setActiveTab,
    searchVal,
    setSearchVal,
    filteredData,
    activeEmp,
    setActiveEmp,
    onFilterChange,
    filteredTableData,
    onSearchEmployee,
    onDeleteTable,
    setTableSearchVal,
    tableSearchVal,
    onStationClick,
    activeStations,
    onAssignTable,
    setActiveStation,
  } = props;

  const revenueCenters = JSON.parse(window.sessionStorage.getItem('auth'))
    ?.revenueCenters;

  const EmpCard = ({ eachEmployee }) => {
    const { employee, stations } = eachEmployee;
    const firstName = employee?.firstName || '';
    const lastName = employee?.lastName || '';
    const name = `${firstName} ${lastName}`.trim();
    const active = eachEmployee?.employee?.id === activeEmp?.employee?.id;
    return (
      <div
        className={cn(style.employeeCard, active ? style.activeClass : '')}
        onClick={() => {
          setActiveEmp(eachEmployee);
          setActiveStation({});
        }}
      >
        <div className={style.profile}>
          <div className={cn(style.primaryDiplayIcon, 'pr-2')}>
            <Profile />
          </div>
          <div className={style.info}>
            <div>{name}</div>
            <div className={style.secondaryText}>{employee?.posId}</div>
            <div className={style.secondaryText}>
              <Table /> : {stations.length}
            </div>
          </div>
        </div>
        <div className={cn('overflow-auto d-flex mr-3 w-100', style.tables)}>
          {stations.map(table => (
            <div
              key={table.number}
              className={style.tableTag}
              onClick={() => onDeleteTable(table, employee, 'delete')}
            >
              <span className={cn('mr-3', style.textTruncate)}>
                {table?.number}
              </span>
              <span className={style.remove}>
                <Minus />
              </span>
            </div>
          ))}
        </div>
        <div
          className={stations?.length > 0 ? style.fill : style.deleteDisable}
          onClick={() => onDeleteTable(_, employee, 'deleteAll')}
        >
          <Dash />
        </div>
      </div>
    );
  };

  const getSelectedStyles = (active, table) => {
    if (active && !table) {
      return `${style.tableCard} ${style.activeClass}`;
    } else if (table && !active) {
      return `${style.activeClasses}`;
    } else if (active && table) {
      return `${style.borderWhite} ${style.activeClasses}`;
    } else {
      return style.tableCard;
    }
  };

  return (
    <>
      <div className={cn(style.contentWrapper, 'p-3')}>
        <div className="row h-100">
          <div className="col-7 pl-0 pt-3">
            <div className={style.header}>
              {FLABEL().ASSIGN_EMPLOYEE_EMPLOYEES}
            </div>
            <Header
              setActiveTab={setActiveTab}
              activeTab={activeTab}
              onSearch={e => onSearchEmployee(e)}
              searchVal={searchVal}
              setSearchVal={setSearchVal}
              onFilterChange={val => onFilterChange(val)}
            />
            <div className={style.employeeTable}>
              {filteredData?.length > 0 ?  filteredData?.map(eachEmployee => {
                return <EmpCard eachEmployee={eachEmployee} />;
              }) : 
              <div className='d-flex justify-content-center align-items-center h-100'>
                {FLABEL().ASSIGN_EMPLOYEE_NO_EMPLOYEES}
              </div>
              }
            </div>
          </div>

          <div className={cn('col-5 p-3', style.tableBg)}>
            <div className={style.header}>
              {FLABEL().ASSIGN_EMPLOYEE_TABLES}
            </div>
            <div className="my-3">
              <form className="position-relative">
                <input
                  type="text"
                  placeholder={FLABEL().ASSIGN_EMPLOYEE_SEARCH}
                  value={tableSearchVal}
                  onChange={e => setTableSearchVal(e.target.value)}
                  className={cn(style.searchInput2, 'col-12 pl-3 pr-5')}
                />
                <div className={style.searchIcon}>
                  <SearchIcon />
                </div>
              </form>
            </div>

            <div className={cn('overflow-auto', filteredTableData?.length > 0 ? style.tablesWrapper : style.noData)}>
              {filteredTableData?.length > 0 ? (
                filteredTableData?.map((table, i) => {
                  const revenueCenterName = revenueCenters?.find(
                    x => x.id === table.station?.revenueCenterId
                  )?.name;
                  const active = activeStations?.[table?.station?.id];
                  const isTableAssigned =
                    Array.isArray(table.employees) &&
                    table.employees.length > 0;
                  return (
                    <div className="col-12 px-0" key={table.id}>
                      <div
                        onClick={() => onStationClick(table.station)}
                        className={cn(
                          'text-center',
                          getSelectedStyles(active, isTableAssigned)
                        )}
                      >
                        <div className={style.fillData}>
                          {table?.station?.number?.trim()?.length > 5
                            ? table?.station?.number
                                ?.trim()
                                ?.substring(0, 3)
                                .concat('...')
                            : table?.station?.number}
                        </div>
                        <div
                          className={cn(
                            'mt-2',
                            style.revenueName,
                            style.secondaryText
                          )}
                        >
                          {revenueCenterName?.trim()
                            ? revenueCenterName
                            : '\u00A0'}
                        </div>
                      </div>
                    </div>
                  );
                })
              ) : (
                <div className="fs-12 d-flex justify-content-center align-items-center text-center">
                  {FLABEL().ASSIGN_EMPLOYEE_NO_TABLES}
                </div>
              )}
            </div>
            <button
              className={cn(
                Object.entries(activeStations)?.length > 0
                  ? style.assign
                  : style.assignDisable,
                'w-100 mt-3'
              )}
              onClick={() => onAssignTable(activeStations)}
            >
              {FLABEL().ASSIGN_EMPLOYEE_ASSIGN}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default EmployeeView;
EmployeeView.propTypes = {
  activeTab: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  setActiveTab: PropTypes.func,
  searchVal: PropTypes.string,
  setSearchVal: PropTypes.func,
  filteredData: PropTypes.arrayOf(
    PropTypes.shape({
      employee: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        firstName: PropTypes.string,
        lastName: PropTypes.string,
        posId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      }),
      stations: PropTypes.array,
    })
  ),
  activeEmp: PropTypes.shape({
    employee: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
  }),
  setActiveEmp: PropTypes.func,
  onFilterChange: PropTypes.func,
  filteredTableData: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      station: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        number: PropTypes.string,
        revenueCenterId: PropTypes.oneOfType([
          PropTypes.string,
          PropTypes.number,
        ]),
      }),
      employees: PropTypes.array,
    })
  ),
  onSearchEmployee: PropTypes.func,
  onDeleteTable: PropTypes.func,
  tableSearchVal: PropTypes.string,
  setTableSearchVal: PropTypes.func,
  onStationClick: PropTypes.func,
  activeStations: PropTypes.objectOf(PropTypes.object),
  onAssignTable: PropTypes.func,
  setActiveStation: PropTypes.func,
};

EmployeeView.defaultProps = {
  activeTab: null,
  setActiveTab: () => {},
  searchVal: '',
  setSearchVal: () => {},
  filteredData: [],
  activeEmp: {},
  setActiveEmp: () => {},
  onFilterChange: () => {},
  filteredTableData: [],
  onSearchEmployee: () => {},
  onDeleteTable: () => {},
  tableSearchVal: '',
  setTableSearchVal: () => {},
  onStationClick: () => {},
  activeStations: {},
  onAssignTable: () => {},
  setActiveStation: () => {},
};
